import { getUrl } from '@fe/utils'

let ua: string

if (typeof document !== 'undefined') {
  // 支付宝真机只有 navigator.swuserAgent
  ua = window.navigator.userAgent || window.navigator.swuserAgent || ''
} else {
  ua = ''
}

export const isSunriseClient = /cdfsunrise/i.test(ua)

export const isMiniProgram = /miniProgram/i.test(ua)

export const isAlipayProgram = /AliApp/i.test(ua)

export const isToutiaoProgram = /toutiaomicroapp/i.test(ua)

export const isAndroid = /android/i.test(ua)

export const isIos = /iphone|ipad|ipod/i.test(ua)

export const isWechat = /micromessenger\/([\d.]+)/i.test(ua)

export const isFeishu = /lark\/([\d.]+)/i.test(ua)

export const isWxWork = /wxwork\/([\d.]+)/i.test(ua) // 企业微信

export const isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua)

export const isBaidu = /(baiduboxapp)\/([\d.]+)/i.test(ua)

export const isQQ = /qq\/([\d.]+)/i.test(ua)

export const isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua)

export const isUCBrowser = /(ucbrowser)\/([\d.]+)/i.test(ua)

export const isQzone = /qzone\/.*_qz_([\d.]+)/i.test(ua)

export const isQuark = /(quark)\/([\d.]+)/i.test(ua)

export const isH5Container = getUrl(window.location.href, 'platform') === 'h5'

export const backToClient = !(isSunriseClient || isMiniProgram || isH5Container || isToutiaoProgram)

export const isOriginalChrome = /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua) && isAndroid && ua.indexOf('Version') < 0

export enum clientEnv {
  'wechat' = '1',
  'android' = '2',
  'ios' = '3',
  'alipay' = '4',
  'web' = '5',
  'douyin' = '6',
}

export type ClientEnv = 'mini' | 'client' | 'web' | 'ios' | 'android' | 'alipay' | 'wechat' | 'cdfh5' | 'douyin'

export function getClientEnv(getSystem?: boolean): ClientEnv {
  if (isMiniProgram || isToutiaoProgram) {
    if (getSystem) {
      if (isWechat) {
        return 'wechat'
      }

      if (isAlipayProgram) {
        return 'alipay'
      }

      if (isToutiaoProgram) {
        return 'douyin'
      }
    }
    return 'mini'
  }
  if (isSunriseClient) {
    if (getSystem) {
      if (isIos) return 'ios'
      if (isAndroid) return 'android'
    }
    return 'client'
  }

  return 'web'
}

export function getHostContext() {
  const env = getClientEnv(true)

  const ctx = {
    alipay: window.my,
    wechat: window.wx?.miniProgram,
    ios: window.sr.client,
    android: window.sr.client,
    client: window.sr.client,
    douyin: window.tt?.miniProgram,
    web: {},
    mini: {},
  }

  return ctx[env]
}
